export default __webpack_public_path__ + "static/media/hero-card.bbd1a73a.png";